<!-- <div class="card-grid">
    <div *ngFor="let promo of promotions" class="promo-card">
        <div class="card-image">
            
            <img *ngIf="shouldShowImage(promo.attachments?.[0]?.fileName)" [src]="promo.attachments[0].filePath"
                alt="Promo Image" />

            <div class="pdf-icon-wrapper" *ngIf="!shouldShowImage(promo.attachments?.[0]?.fileName)">
                <i class="pi pi-file-pdf pdf-icon"></i>
            </div>
        </div>
        <div class="card-content">
            <div>
                <p-button *ngIf="promo.status === 'Approved'"
                    [routerLink]="['/distributor-partners/promotion', promo.promotionId, 'analytics']" [link]="true"
                    label="Analytics" class="dashboard">
                </p-button>
                <h3 class="promo-title">{{ promo.name }}</h3>
                <p class="promo-description">{{ promo.description }}</p>
                <p><strong>Start Date:</strong> {{ promo.startDate | date }}</p>
                <p><strong>End Date:</strong> {{ promo.endDate | date }}</p>
                <a href="#" *ngIf="promo.attachments?.length"
                    (click)="openPreview(promo.attachments[0]); $event.preventDefault()" class="link">
                    Preview File
                </a>
            </div>

            <div class="actions flex justify-content-start flex-wrap">
                <ng-container *ngIf="promo.status === 'Submitted'; else statusStamp">
                    <button pButton type="button" class="btn-primary mr-2" (click)="openActionModal(promo, true)">
                        Approve
                    </button>
                    <button pButton type="button" class="btn-danger" (click)="openActionModal(promo, false)">
                        Reject
                    </button>
                </ng-container>

                <ng-template #statusStamp>
                    <span class="status-stamp" [ngClass]="{
            'approved-stamp': promo.status === 'Approved',
            'rejected-stamp': promo.status === 'Rejected'}">
                        {{ promo.status }}
                    </span>
                </ng-template>
            </div>

        </div>
    </div>
</div>

<div class="empty-state-wrapper" *ngIf="promotions.length === 0">
  <table>
    <tr>
      <td colspan="9">
        <div class="empty-state">
          <img src="assets/image/Group.png" alt="No Data" />
          <p>
            <span class="span1">No promotions Found.</span><br />
            <span *ngIf="searchQuery || dateRange?.length" class="search-info">
              <span *ngIf="searchQuery">
                for "<strong>{{ searchQuery }}</strong>"
              </span>
              <span *ngIf="dateRange?.length">
                between
                <strong>{{ dateRange[0] | date: 'dd MMM, yyyy' }}</strong>
                and
                <strong>{{ dateRange[1] | date: 'dd MMM, yyyy' }}</strong>
              </span>
              .
            </span>
          </p>
        </div>
      </td>
    </tr>
  </table>
</div> -->

<!-- <div class="load-more-wrapper" *ngIf="promotions.length < totalStatusRecords">
    <button pButton label="Load More" class="btn-secondary" (click)="loadMorePromotions()"></button>
</div> -->



<p-table [value]="promotions" *ngIf="promotions.length > 0" class="p-datatable-gridlines" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th>Promotion</th>
      <th>Description</th>
      <th>Start Date</th>
      <th>End Date</th>
      <th>Attachment</th>
      <th *ngIf="hasApprovedOrRejectedPromotions()">Status</th>
      <th *ngIf="hideRejectedPromotions()">Actions</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-promo>
    <tr>
      <td class="promotion-name">
        <div class="avatar">{{ getAvatarText(promo.name) }}</div>
        <span>{{ promo.name }}</span>
      </td>
      <td>{{ promo.description }}</td>
      <td>{{ promo.startDate | date: 'dd MMM, yyyy' }}</td>
      <td>{{ promo.endDate | date: 'dd MMM, yyyy' }}</td>

      <td>
        <a *ngIf="promo.attachments?.length" href="#"
           (click)="openPreview(promo.attachments[0]); $event.preventDefault()" class="link">
          {{ promo.attachments[0]?.fileName || getAttachmentName(promo.attachments[0]?.filePath) }}
        </a>
      </td>

      <td  *ngIf="promo.status === 'Approved' || promo.status === 'Rejected'">
        <!-- <ng-container *ngIf="promo.status === 'Submitted'; else statusStamp">
          <button pButton type="button" class="p-button-sm p-button-success mr-2"
                  (click)="openActionModal(promo, true)">
            Approve
          </button>
          <button pButton type="button" class="p-button-sm p-button-danger"
                  (click)="openActionModal(promo, false)">
            Reject
          </button>
          *ngIf="hasApprovedOrRejectedPromotions()"
        </ng-container> -->
        
          <span class="status-stamp"
                [ngClass]="{
                  'approved-stamp': promo.status === 'Approved',
                  'rejected-stamp': promo.status === 'Rejected'
                }">
            {{ promo.status }}
          </span>
       
      </td>

       <td *ngIf="promo.status === 'Approved' || promo.status === 'Submitted'">
        <ng-container *ngIf="promo.status === 'Submitted'">
          <button pButton type="button" class="btn-primary mr-2 btn"
                  (click)="openActionModal(promo, true)">
            Approve
          </button>
          <button pButton type="button" class="danger btn"
                  (click)="openActionModal(promo, false)">
            Reject
          </button>
        </ng-container>
        <p-button *ngIf="promo.status === 'Approved'"
                  [routerLink]="['/distributor-partners/promotion', promo.promotionId, 'analytics']"
                  [link]="true"
                  label="Analytics"
                  class="p-button-sm p-button-text">
        </p-button>
      </td>

    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
        <tr>
            <td colspan="9">
                <div class="  flex justify-content-between">
                    <div class="flex  align-items-center">
                        <div class="page-info">Page: {{ pageNumber }} of {{ totalPages }}</div>
                    </div>
                    <div class="flex justify-content-end">
                        <button type="button" (click)="previousPage()" [disabled]="pageNumber === 1"
                            class="p-paginate pagination-button mr-2">
                            Previous
                        </button>
                        <button type="button" (click)="nextPage()" [disabled]="pageNumber >= totalPages"
                            class="p-paginate pagination-button">
                            Next
                        </button>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<!-- Empty State -->
<div class="empty-state-wrapper" *ngIf="promotions.length === 0">
  <div class="empty-state">
    <img src="assets/image/Group.png" alt="No Data" />
    <p>
      <span class="span1">No promotions Found.</span><br />
      <span *ngIf="searchQuery || dateRange?.length" class="search-info">
        <span *ngIf="searchQuery">for "<strong>{{ searchQuery }}</strong>"</span>
        <span *ngIf="dateRange?.length">
          between
          <strong>{{ dateRange[0] | date: 'dd MMM, yyyy' }}</strong> and
          <strong>{{ dateRange[1] | date: 'dd MMM, yyyy' }}</strong>
        </span>.
      </span>
    </p>
  </div>
</div>